import { ROUTE_PATHS, ROUTE_TO_PERMISSIONS_MAP } from "const/paths";
import { useUserContext } from "contexts/UserContext";
import useHasPermissions from "hooks/useHasPermissions";
import { Navigate, useLocation } from "react-router-dom";
import { isKeyOfObject } from "utils/types";
import { useVenueContext } from "contexts/VenueContext";

import { AuthAccessibilityType } from "./enums";
import { AuthAccessibilityProps } from "./types";

const AuthAccessibility: React.FC<AuthAccessibilityProps> = ({
  children,
  authAccessibility,
}) => {
  const { user } = useUserContext();
  const { venue } = useVenueContext();
  const { pathname } = useLocation();
  const permissions = isKeyOfObject(pathname, ROUTE_TO_PERMISSIONS_MAP)
    ? ROUTE_TO_PERMISSIONS_MAP[pathname]
    : [];
  const hasPermissions = useHasPermissions(permissions);

  if (user && authAccessibility === AuthAccessibilityType.onlyNotLoggedIn) {
    return <Navigate to={ROUTE_PATHS.Dashboard} />;
  }

  if (
    !user &&
    (authAccessibility === AuthAccessibilityType.onlyLoggedIn ||
      authAccessibility === AuthAccessibilityType.onlyVenueSelected)
  ) {
    return <Navigate to={ROUTE_PATHS.Login} />;
  }

  if (
    user &&
    authAccessibility === AuthAccessibilityType.onlyLoggedIn &&
    !hasPermissions
  ) {
    return <Navigate to={ROUTE_PATHS.Dashboard} />;
  }

  if (!venue && authAccessibility === AuthAccessibilityType.onlyVenueSelected) {
    return <Navigate to={ROUTE_PATHS.VenueLogin} />;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default AuthAccessibility;
